import { SvgIcon } from "@material-ui/core";
import moment from "moment";
import React, { useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import globalColors from "../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import clients from "../../../../assets/icons/clientes.svg";
import { ReactComponent as iconPlus } from "../../../../assets/icons/icon-plus-green.svg";
import CrudActions from "../../../../partials/datatable/CrudActions";
import Datatable from "../../../../partials/datatable/Datatable";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../partials/datatable/styles";
import { AppAPIService } from "../../../../services/AppAPIService";
import StatusBadge from "../../../../components/StatusBadge";
import Loading from "../../../home/components/Loading";

const ClientListing = (props) => {
  let api = AppAPIService.getInstance();

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);

  const [profiles] = useState([]);

  window.setPageTitle("Listagem de Clientes - Admin");

  const handleConfirmDelete = async (id) => {
    try {
      setLoading(true);
      await api.makeHttpRequest({
        method: "DELETE",
        url: `/client/${id}`,
      });

      setReload(!reload);
      setLoading(false);
      Swal.fire({
        title: "Sucesso!",
        text: "Cliente deletado com sucesso.",
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao deletar cliente.", "error");
    }

    setLoading(false);
  };

  const handleConfirmChangeStatus = async (obj) => {
    try {
      await api.makeHttpRequest({
        method: "PATCH",
        url: `/client/toggle/${obj.id}`,
        data: {
          active: !obj.active,
        },
      });

      setReload(!reload);

      const clientStatus = !obj.active ? "ativado" : "desativado";

      Swal.fire({
        title: "Sucesso!",
        text: `Usuário ${clientStatus} com sucesso!`,
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao alterar status.", "error");
    }
  };

  const headRows = [
    { column: "Opções", label: "Ações", sortable: false },
    { column: "name", label: "Nome" },
    { column: "email", label: "Email" },
    { column: "document", label: "CPF/CNPJ" },
    { column: "responsiblePhone", label: "Telefone" },
    { column: "active", label: "Status" },
    { column: "updatedAt", label: "Data de modificação" },
  ];

  const formatRow = (r) => {
    let crudActions = ["delete", "toggle", "edit"];
    return (
      <StyledTableRow key={r.id} hover tabIndex={-1}>
        <StyledTableCell
          scope="row"
          style={{ padding: "0px 10px", width: "48px" }}
        >
          <CrudActions
            actions={crudActions}
            module="cliente"
            onConfirmChangeStatus={handleConfirmChangeStatus}
            onConfirmDelete={handleConfirmDelete}
            id={r.id}
            obj={r}
            titleMessageDelete={""}
            addMessage={"Deseja deletar esse usuário?"}
          />
        </StyledTableCell>
        <StyledTableCell scope="row" style={{ padding: "4px 0px" }}>
          {r.name}
        </StyledTableCell>
        <StyledTableCell scope="row" style={{ padding: "4px 0px" }}>
          {r.email}
        </StyledTableCell>
        <StyledTableCell scope="row" style={{ padding: "4px 0px" }}>
          {r.document}
        </StyledTableCell>
        <StyledTableCell scope="row" style={{ padding: "4px 0px" }}>
          {r.responsiblePhone}
        </StyledTableCell>
        <StyledTableCell scope="row" style={{ padding: "4px 0px" }}>
          <StatusBadge value={r.active ? "active" : "inactive"} />
        </StyledTableCell>
        <StyledTableCell scope="row" style={{ padding: "4px 0px" }}>
          {r.updatedAt
            ? moment(r.updatedAt).format("DD/MM/YYYY")
            : "--/--/----"}
        </StyledTableCell>
      </StyledTableRow>
    );
  };

  return (
    <>
      <Loading isLoading={loading} />
      <Datatable
        title="Clientes"
        icon={<img src={clients} alt="Adicionar" />}
        endpoint="/client/list-paginated"
        className="bg-white"
        headRows={headRows}
        formatRow={formatRow}
        rows={[]}
        reload={reload}
        placeholderSearch="Busque por nome/razão social, email ou CPF/CNPJ"
        width={props.width}
        tooltip="Cadastrar nova pessoa"
        hiddenReload
        personInputs
        personStatusFilter={profiles}
        addButtonUrl="/admin/cliente/adicionar"
        hiddenKanbanContent
        colorButton={globalColors.transparent}
        titleButon={
          <SvgIcon
            component={iconPlus}
            alt="Cadastrar novo cliente"
            fill={globalColors.primaryColor1}
            viewBox="0 0 16 15"
            style={{
              width: "30px",
              height: "32px",
              fill: globalColors.primaryColor1,
              color: globalColors.primaryColor1,
            }}
          />
        }
      />
    </>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(ClientListing);
